
// Font awesome list of icons that can be used throughout the whole app
// We use this instead of downloading the whole font/svg from font awesome

import { library } from '@fortawesome/fontawesome-svg-core'
import {
    faAddressCard,
    faMoneyCheckAlt,
    faExchangeAlt,
    faUserShield,
    faFileAlt,
    faMobileAlt,
    faSortAmountUp,
    faUsers,
    faArrowAltCircleRight,
    faMoneyBillWave,
    faStar,
    faForward,
    faBookOpen,
    faCheckCircle,
    faTag,
    faQuestionCircle,
    faBabyCarriage,
    faHandsHelping,
    faBusinessTime,
    faProcedures,
    faCogs,
    faChartBar,
    faChessRook,
    faDatabase,
    faCloud,
    faLightbulb,
    faShieldAlt,
    faEnvelopeOpenText,
    faComments,
    faMapMarkedAlt,
    faArrowLeft,
    faPhone,
    faCircle,
    faSmile,
    faGlobeAmericas,
    faCalendarCheck,
    faChartLine,
    faUserClock,
    faMedal,
    faUserTag,
    faUserPlus,
    faEdit,
    faPeopleArrows,
    faBuilding,
    faChalkboardTeacher,
} from '@fortawesome/free-solid-svg-icons'


import {
    faEye,
    faEyeSlash
} from '@fortawesome/free-solid-svg-icons'


import {
    faFacebook
} from '@fortawesome/free-brands-svg-icons'

// brands
library.add(faFacebook)

// free
library.add(faEye)
library.add(faEyeSlash)

// solid
library.add(faAddressCard)
library.add(faMoneyCheckAlt)
library.add(faExchangeAlt)
library.add(faUserShield)
library.add(faUsers)
library.add(faFileAlt)
library.add(faMobileAlt)
library.add(faSortAmountUp)
library.add(faArrowAltCircleRight)
library.add(faMoneyBillWave)
library.add(faStar)
library.add(faForward)
library.add(faBookOpen)
library.add(faCheckCircle)
library.add(faTag)
library.add(faQuestionCircle)
library.add(faBabyCarriage)
library.add(faHandsHelping)
library.add(faBusinessTime)
library.add(faProcedures)
library.add(faCogs)
library.add(faChartBar)
library.add(faChessRook)
library.add(faDatabase)
library.add(faCloud)
library.add(faLightbulb)
library.add(faShieldAlt)
library.add(faEnvelopeOpenText)
library.add(faComments)
library.add(faMapMarkedAlt)
library.add(faArrowLeft)
library.add(faPhone)
library.add(faCircle)
library.add(faSmile)
library.add(faGlobeAmericas)
library.add(faCalendarCheck)
library.add(faChartLine)
library.add(faUserClock)
library.add(faMedal)
library.add(faUserTag)
library.add(faUserPlus)
library.add(faEdit)
library.add(faPeopleArrows)
library.add(faBuilding)
library.add(faChalkboardTeacher)
